import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  resolveCaptcha
} from "./chunk-UELQYFJ7.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/interest/register.ts
import { Exception } from "@wbk/logger";
var registerInterest = (props) => __async(null, null, function* () {
  var _a, _b;
  try {
    const captcha = yield resolveCaptcha("interest");
    const data = yield fetchClient({
      url: "/halayalla/booking-interest",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadValues(__spreadProps(__spreadValues({}, props), {
          type: props.type === "experience" ? "experience" : "event"
        }), captcha)),
        headers: {
          Authorization: ""
        }
      }
    });
    if (((_a = data == null ? void 0 : data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      const possibleErrors = data.error || {};
      const msg = typeof possibleErrors === "string" ? possibleErrors : (_b = Object.values(possibleErrors)) == null ? void 0 : _b[0];
      const msgString = Array.isArray(msg) ? msg[0] : msg;
      throw new Error(msgString || "Something went wrong");
    }
  } catch (error) {
    throw new Exception({
      name: "registerInterestException",
      error
    });
  }
});

export {
  registerInterest
};
//# sourceMappingURL=chunk-CDFP2POK.mjs.map